import type { WhenSelection } from "@ui/components/SearchBar";
import { useCallback, useMemo, useState } from "react";
import { type SearchWindow, whenSelectionToWindow } from "@/lib/when-search-window";

const EMPTY_WHEN: WhenSelection = { start: null, end: null };

export interface UseSearchBarWhenReturn {
  whenProps: {
    value: WhenSelection;
    onChange: (value: WhenSelection) => void;
  };
  /** Resolved `[gte, lte]` window for the search filter, or null when nothing is selected. */
  whenWindow: SearchWindow | null;
  resetWhen: () => void;
}

/**
 * Holds the SearchBar "When" selection for /programs and derives the date window
 * the search request filters on. Mirrors `useSearchBarWhere` but far simpler — the
 * selection is pure client state with no async resolution.
 */
export function useSearchBarWhen(initial?: WhenSelection): UseSearchBarWhenReturn {
  const [value, setValue] = useState<WhenSelection>(initial ?? EMPTY_WHEN);
  const whenWindow = useMemo(() => whenSelectionToWindow(value), [value]);
  const resetWhen = useCallback(() => setValue(EMPTY_WHEN), []);

  return { whenProps: { value, onChange: setValue }, whenWindow, resetWhen };
}
